import { cx } from '@linaria/core';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const transitionCls = "dibtl04n0b";
const ReadOutLoudIcon = ({
  color = "currentColor",
  playOnly,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 24),
    ...svgProps,
    className: cx(svgProps.className, transitionCls, playOnly && "playOnly"),
    viewBox: "0 0 25 25",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.8",
    children: [/*#__PURE__*/jsx("path", {
      className: "speechBubble",
      d: "M13.3.9C7.3.9 2.5 5.7 2.5 11.7c0 2 .6 4 1.6 5.7L.9 24.1l6.7-3.2c5.1 3.1 11.7 1.6 14.9-3.5 3.1-5.1 1.6-11.7-3.5-14.9C17.3 1.4 15.3.9 13.3.9z"
    }), /*#__PURE__*/jsx("path", {
      className: "play",
      d: "M11.4 15.3c-.4.2-1 0-1.2-.4h0c-.1-.1-.1-.3-.1-.4V8.6c0-.5.4-.9.9-.9h0c.1 0 .3 0 .4.1l5.9 3c.4.2.6.7.4 1.2-.1.2-.2.3-.4.4l-5.9 2.9z"
    })]
  });
};

export { ReadOutLoudIcon };
import "./read-out-loud.linaria.module.css";
//# sourceMappingURL=read-out-loud.js.map
